import { Link } from "react-router-dom";
import { LogoMark } from "@/components/LogoMark";

const APP_URL = "https://schema-analysis-hub.emergent.host";

const cols = [
  {
    title: "Platform",
    items: [
      { label: "Create", href: "/#features" },
      { label: "Validate", href: "/#features" },
      { label: "Compare", href: "/#features" },
      { label: "Profile", href: "/#features" },
    ],
  },
  {
    title: "Audiences",
    items: [
      { label: "For Councils", href: "/for-councils" },
      { label: "For Consultants", href: "/for-consultants" },
      { label: "Pricing", href: "/#pricing" },
      { label: "How It Works", href: "/#how-it-works" },
      { label: "FAQ", href: "/#faq" },
    ],
  },
  {
    title: "Company",
    items: [
      { label: "Existing users", href: APP_URL },
      { label: "Book a demo", href: "/contact" },
      { label: "Talk to us", href: "/contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#121316] text-zinc-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="h-8 w-8 grid place-items-center bg-[#0033A0] text-white">
                <LogoMark size={18} />
              </span>
              <span className="font-heading text-lg font-semibold text-white">WebADAC</span>
            </Link>
            <p className="mt-4 text-sm text-zinc-400 leading-relaxed max-w-xs">
              The ADAC XML workflow platform for Councils and Consultants. Validate, compare,
              profile, and create compliant XML with confidence.
            </p>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-heading text-sm font-semibold text-white tracking-wide">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.items.map((i) => (
                  <li key={i.label}>
                    <a
                      href={i.href}
                      className="text-sm text-zinc-400 hover:text-white transition-colors"
                    >
                      {i.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-zinc-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-500 font-mono">
            © {new Date().getFullYear()} WebADAC. ADAC XML workflow platform.
          </p>
          <p data-testid="powered-by" className="text-xs text-zinc-500 font-mono">
            Powered by{" "}
            <a
              href="https://cbkm.au/"
              target="_blank"
              rel="noreferrer"
              className="hover:opacity-80 transition-opacity"
            >
              <span style={{ color: "#d4af37", fontWeight: 800, letterSpacing: "0.02em" }}>CBKM</span>
              <span className="text-zinc-500">.au</span>
            </a>
          </p>
        </div>

        <div className="mt-4 text-center md:text-right">
          <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs text-zinc-600 hover:text-zinc-400 transition-colors font-mono">
            Admin
          </Link>
        </div>
      </div>

      <div className="overflow-hidden select-none" aria-hidden="true">
        <p className="font-heading font-semibold text-[18vw] leading-none text-center text-white/[0.03] -mb-[3vw] tracking-tighter">
          WebADAC
        </p>
      </div>
    </footer>
  );
}
